/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Tab, Nav } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import classNames from 'classnames';
import LeafletMap from 'components/common/map/LeafletMap';

const TabTitle = ({ title, value, percentage, progress }) => (
  <div className="p-2 pe-4 text-start cursor-pointer">
    {title && <h6 className="text-800 fs--2 text-nowrap">{title}</h6>}
    {value && <h5 className="text-800">{value}</h5>}
    {percentage && (
      <Flex alignItems="center">
        <FontAwesomeIcon
          icon={progress ? 'caret-up' : 'caret-down'}
          className={progress ? 'text-success' : 'text-warning'}
        />
        <h6
          className={`fs--2 mb-0 ms-2 ${
            progress ? 'text-success' : 'text-warning'
          }`}
        >
          {percentage}
        </h6>
      </Flex>
    )}
  </div>
);

const SoilMaps = ({ data, className }) => {
  return (
    <Card className={classNames(className, 'overflow-hidden')}>
      <Tab.Container id="audience-tab" defaultActiveKey={data[0].key}>
        <SimpleBarReact>
          <Card.Header className="p-0 bg-light">
            <Nav className="nav-tabs border-0 flex-nowrap chart-tab">
              {data.map(item => (
                <Nav.Item key={item.key}>
                  <Nav.Link className="mb-0" eventKey={item.key}>
                    <TabTitle value={item.title} />
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Card.Header>
        </SimpleBarReact>

        <Card.Body className="p-0">
          <Tab.Content>
            {data.map((item, index) => (
              <Tab.Pane key={item.key} unmountOnExit eventKey={item.key}>
                <LeafletMap
                  data={{ coordinates: item.coordinates, mapData: item }}
                  className="h-100 bg-white"
                  style={{ minHeight: '410px' }}
                  key={`${item.key}-${index}-land-locations`}
                />
                <Card.Footer className="bg-white py-2 card-footer-style">
                  <h5 className="mb-0 infrence-info">{item.info}</h5>
                </Card.Footer>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};

export default SoilMaps;
